module.exports = __webpack_public_path__ + "static/media/ranking.b0ef74ac.svg";